import * as React from "react";
import { UploadPermissionNotificationModel } from "@/views/drive/modals/uploadPermissionNotificationModal";
import { useGetFileDetailsQuery } from "@/api/files";

interface Props {
  fseId: string;
  onProceed: () => void;
  onCancel: () => void;
}

export const UploadModalPermissionNotification: React.FC<Props> = ({ fseId, onProceed, onCancel }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const decisionResolvedRef = React.useRef(false);
  const { data, isError } = useGetFileDetailsQuery({ fse_id: fseId });

  React.useEffect(() => {
    if (decisionResolvedRef.current || (!data && !isError)) return;
    const requiresConsent =
      isError || (data?.owner_id !== "system" && (data?.access === "public" || (data?.permissions.length ?? 0) > 1));
    if (requiresConsent) {
      setIsOpen(true);
      return;
    }
    decisionResolvedRef.current = true;
    onProceed();
  }, [data, isError, onProceed]);

  const handleAccept = React.useCallback(() => {
    if (decisionResolvedRef.current) return;
    decisionResolvedRef.current = true;
    setIsOpen(false);
    onProceed();
  }, [onProceed]);

  const handleCancel = React.useCallback(() => {
    if (decisionResolvedRef.current) return;
    decisionResolvedRef.current = true;
    setIsOpen(false);
    onCancel();
  }, [onCancel]);

  return isOpen ? <UploadPermissionNotificationModel handleAccept={handleAccept} handleClose={handleCancel} /> : null;
};
